import React, { useEffect, useState } from 'react';
import Head from 'next/head';

import { Header } from 'src/components';
import { Analytics } from 'src/analytics';
import { AppStateContextProvider } from 'src/hooks/useAppState';
import AuthService from 'src/services/authService';
import { UserData } from 'src/types';

const AnalyticsPage = () => {
  const [user, setUser] = useState<UserData | null>(null);

  useEffect(() => {
    setUser(AuthService.getCurrentUser());
  }, []);

  return (
    <AppStateContextProvider>
      <Head>
        <title>Homeppl Ops</title>
      </Head>

      <Header user={user} currentPage="Analytics" />
      <Analytics />
    </AppStateContextProvider>
  );
};

export default AnalyticsPage;
